import { useState } from 'react';
import { Tabs, Tab, Box, Card } from '@mui/material';
import PropTypes from 'prop-types';
import GlConsolidationFacility from './GlConsolidationFacility';

GlConsolidationTabs.propTypes = {
  gridSx: PropTypes.object,
  childHeightSx: PropTypes.object,
};

export default function GlConsolidationTabs({ gridSx, childHeightSx }) {
  const [tab, setTab] = useState(0);

  const handleChange = (_, newValue) => setTab(newValue);
  const isManual = tab === 0;

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box>
        <Tabs value={tab} onChange={handleChange}>
          <Tab label="Manual" />
          <Tab label="Electronic" />
        </Tabs>
      </Box>

      <GlConsolidationFacility
        isManual={isManual}
        gridSx={gridSx}
        heightSx={childHeightSx}
      />
    </Card>
  );
}